import React from "react";
import { Select } from "antd";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Icon from "@ant-design/icons";
import { ArrowDownSvg } from "../../assets/icons";

const ArrowDownIcon = (props) => <Icon component={ArrowDownSvg} {...props} />;

export const CustomPagination = ({ total, current, pageSize, onChange, onShowSizeChange }) => {
  const totalPages = Math.ceil(total / pageSize);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 7;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    pages.push(1);

    let startPage = Math.max(current - 1, 2);
    let endPage = Math.min(startPage + 2, totalPages - 1);

    if (endPage === totalPages - 1) {
      startPage = endPage - 2;
    }

    if (startPage > 2) {
      pages.push("...");
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push("...");
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="bg-[#fafafa] flex items-center justify-between px-4 py-3 rounded-[0_0_1.5rem_1.5rem] border-[0.5px] border-[#0000000f]">
      {/* Page size selector */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-700 font-[Inter]">Rows per page</span>
        <Select
          value={pageSize}
          onChange={(value) => onShowSizeChange(current, value)}
          options={[
            { value: 10, label: "10" },
            { value: 20, label: "20" },
            { value: 50, label: "50" },
            { value: 100, label: "100" },
          ]}
          className="w-16"
          style={{ height: '32px' }}
          suffixIcon={<ArrowDownIcon />}
          classNames={{ popup: { root: "min-w-[100px]" } }}
        />
      </div>

      {/* Pagination navigation */}
      <div className="flex items-center gap-1">
        {/* Page numbers */}
        {getPageNumbers().map((pageNum, index) => {
          if (pageNum === "...") {
            return (
              <span
                key={`ellipsis-${index}`}
                className="w-8 h-8 flex items-center justify-center text-gray-500"
              >
                ...
              </span>
            );
          }
          return (
            <button
              key={pageNum}
              onClick={() => onChange(pageNum, pageSize)}
              className={`
                min-w-8 h-8 px-2 rounded-[8px] text-sm font-normal flex items-center justify-center font-[Inter] transition-colors border-[2px]
                ${current === pageNum
                  ? "bg-white border-[#0e49b5] text-[#0e49b5]"
                  : "bg-white border-transparent text-gray-700 hover:bg-gray-100"
                }
              `}
            >
              {pageNum}
            </button>
          );
        })}

        {/* Previous button */}
        <button
          onClick={() => onChange(current - 1, pageSize)}
          disabled={current === 1}
          className="flex items-center justify-center w-8 h-8 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-gray-500"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>

        {/* Next button */}
        <button
          onClick={() => onChange(current + 1, pageSize)}
          disabled={current === totalPages}
          className="flex items-center justify-center w-8 h-8 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-gray-500"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}; 